import React from 'react';
import BasketContainer from '../containers/BasketContainer';
import BasketModalComponent from './BasketModalComponent';

const BasketModal = (props) => (
  <BasketContainer childComponent={BasketModalComponent} {...props} />
);

export default BasketModal;
